import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import alarmsConfigShape from '../../../shapes/alarmsConfigShape';
import NewAlarmConfigModalContainer from './NewAlarmConfigModalContainer';
import TableWithFetch from '../../reusable/TableWithFetch';
import usersConfigEditShape from '../../../shapes/usersConfigEditShape';
import userSchema from '../../../schemas/user';

const SettingsAlarms = (props) => {
  const {
    t, alarmsConfig, openNewAlarmConfigModal,
    openEditAlarmsConfigModal, getAlarmsConfig, loadMore,
    openDeleteMachineConfigModal, closeDeleteMachineConfigModal, deleteMachineConfig,
    closeEditAlarmsConfigModal, submitAlarmConfig,
  } = props;
  return (
    <TableWithFetch
      fetchAction={getAlarmsConfig}
      isLoading={alarmsConfig.isPending}
      shape={alarmsConfigShape}
      loadMoreAction={() => loadMore()}
      editable
      doubleRowEditable
      doubleHeaderRow
      content={alarmsConfig}
      withAddButton={{
        iconName: 'alarm',
        label: t('common.add'),
        isModalOpen: alarmsConfig.isAddModalOpen,
        openModalAction: openNewAlarmConfigModal,
        containerElem: NewAlarmConfigModalContainer,
      }}
      openEditModalAction={openEditAlarmsConfigModal}
      editModalProps={{
        containerElem: NewAlarmConfigModalContainer,
        closeModalAction: closeEditAlarmsConfigModal,
        updateItemAction: submitAlarmConfig,
        titleFormat: '%s',
        titleValues: ['machineShortName'],
        shape: usersConfigEditShape,
        schema: userSchema,
        validation: alarmsConfig.validation,
        size: 'tiny',
        btnText: t('common.update'),
        isPending: alarmsConfig.isPendingUpdate,
      }}
      openDeleteModalAction={openDeleteMachineConfigModal}
      deleteModalProps={{
        closeModalAction: closeDeleteMachineConfigModal,
        deleteAction: deleteMachineConfig,
        textFormat: t('alarmsConfig.confirm-delete'),
        textValues: ['machineShortName'],
        title: t('common.delete'),
        isPending: alarmsConfig.isPendingDelete,
      }}
    />
  );
};

SettingsAlarms.propTypes = {
  t: PropTypes.func.isRequired,
  getAlarmsConfig: PropTypes.func.isRequired,
  submitAlarmConfig: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  openDeleteMachineConfigModal: PropTypes.func.isRequired,
  closeDeleteMachineConfigModal: PropTypes.func.isRequired,
  closeEditAlarmsConfigModal: PropTypes.func.isRequired,
  deleteMachineConfig: PropTypes.func.isRequired,
  openNewAlarmConfigModal: PropTypes.func.isRequired,
  openEditAlarmsConfigModal: PropTypes.func.isRequired,
  alarmsConfig: PropTypes.shape({}).isRequired,
};

export default translate()(SettingsAlarms);



// WEBPACK FOOTER //
// ./src/components/Settings/alarms/SettingsAlarms.js